export const nameStartRegex = new RegExp(/^[^\\\/<>|}@{%$?*&~#""]*[^*]$/);

export const nameEndRegex = new RegExp(/^[^*]*[^\\\/<>%$|}@{?*&.,~#"":]$/);
